module.exports = __webpack_public_path__ + "img/oaks-nest-bathroom-2.ac2b1dda.jpeg";